// for test only
const gamesSkipPlayNowScreen = [];
const gamesSkipPreroll = [];

export const isSkipPlayNowScreen = (slug: string) => {
  return gamesSkipPlayNowScreen.indexOf(slug) !== -1;
};

export const isSkipPreroll = (slug: string) => {
  return gamesSkipPreroll.indexOf(slug) !== -1;
};
